import React, { useEffect, useState } from 'react'
import CommonReactTable from '../../CommonUtils/CommonReactTable'
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { FaDownload } from 'react-icons/fa';
import { viewImage } from '../../CommonUtils/viewImage';
import { useNavigate } from 'react-router-dom';
import { InfoAlert } from '../../CommonUtils/SweetAlerts';
import { useDispatch } from 'react-redux';
import { IoEye } from "react-icons/io5";

export default function CollegeSubmissionDocuments() {
    const acYear = sessionStorage.getItem('ac_year');
    const [showUniversityData, setUniversityData] = useState([]);
    const [showTotalCollegesUniversityWiseData, setTotalCollegesUniversityWiseData] = useState([]);
    const [showDrillCount, setDrillCount] = useState();
    const [showUniversitywiseTable, setUniversitywiseTable] = useState(false);
    const [showClgBuildingDetailsTable, setClgBuildingDetailsTable] = useState(false);
    const [showBuildingBlockDetailsTable, setBuildingBlockDetailsTable] = useState(false);
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [showuniversityName, setUniversityName] = useState("")

    function NavtoMobileAppPhotos(clgcode) {
        navigate("/AfflFfcaAppUploads")
        dispatch({ type: "COLLEGE_CODE", payload: clgcode });
    }

    function navtofaculaty(collcode) {
        localStorage.setItem("collegeCode", collcode);
        navigate("/FfcaEmployeeDetails_21")

    }

    function navigatetoCommitephotos(clgcode) {
        dispatch({ type: "COLLEGE_CODE", payload: clgcode });
        navigate("/AfflFfcaCommittePhoto")

    }

    const Columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "University Name", accessor: "ub_name", Footer: "",
            Cell: ({ row }) => (
                <div className='text-left'>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "Total Colleges", accessor: "sum", Footer: "sum",


            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue", textDecoration: "underline" }}
                    onClick={() => {
                        if (row?.original?.sum === 0) {
                            InfoAlert("No Data Found")
                        }
                        else {
                            GettUniversityWiseCollegeDetails(row?.original?.ub_code);
                            setUniversityName(row?.original?.ub_name)
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GettUniversityWiseCollegeDetails(row?.original?.ub_code);
                            setUniversityName(row?.original?.ub_name)
                        }
                    }}  >{row?.values?.sum}</div>
            ),
        },
    ]

    const totalcollegeColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "College Code", accessor: "coll_code",
        },

        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },
        {
            Header: "College Address", accessor: "inst_address",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_address}</div>
            ),
        },
        {
            Header: "Proof of Address", accessor: "inst_addr_proof_type", Footer: "inst_addr_proof_type",
            Cell: ({ row }) => {
                const value = row?.original?.inst_addr_proof_type.split("@@@")
                return (
                    <div style={{ textAlign: 'left' }}>
                        {/* {value[0]} */}
                        <button type="button" className="btn text-center" onClick={() => { viewImage(value[1]) }}>
                            <FaDownload size={20} />
                        </button>
                    </div>)
            },
        },
        {
            Header: "Geo Location (Address)", accessor: "lat_long_name", Footer: "lat_long_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.lat_long_name}</div>
            ),
        },
        {
            Header: "AICTE Order", accessor: "aicte",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.aicte === "-" ? ("-") : (
                        <button type="button" className="btn text-center"
                            onClick={() => { viewImage(row?.original?.aicte) }}>
                            <FaDownload size={20} /> </button>)
                    }</>)
            }
        },
        {
            Header: "Previous Affilaition Order", accessor: "affl_order", Footer: "affl_order",
            Cell: ({ row }) => {
                const affilvalue = row?.original?.affl_order.split("@@@")
                return (
                    <div className='text-left'>
                        {/* {affilvalue[0]} */}
                        <button type="button" className="btn text-center" onClick={() => { viewImage(affilvalue[1]) }}>
                            <FaDownload size={20} />
                        </button>
                    </div>)
            },
        },
        {
            Header: "Faculty Report", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { navtofaculaty(row?.original?.coll_code) }}
                    >VIEW </button>
                </>)
            }
        },
        {
            Header: "Building Type", accessor: "building_type", Footer: "building_type",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'right' }}>{row?.values?.building_type}</div>
            ),
        },
        {
            Header: "College Building Details", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { viewCollegeBuldingDetails(row?.original?.coll_code) }}>
                        VIEW </button>
                </>)
            }
        },
        {
            Header: "Building Block Details & Pictures", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { viewBuldingBlockDetails(row?.original?.coll_code) }}>
                        VIEW </button>
                </>)
            }
        },
        {
            Header: "Classroom Details & Pictures", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { viewClassRoomDetails(row?.original?.coll_code) }}>
                        VIEW </button>
                </>)
            }
        },
        {
            Header: "Laboratory Details & Pictures", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { viewLaboratoryDetails(row?.original?.coll_code) }}>
                        VIEW </button>
                </>)
            }
        },
        {
            Header: `Documents submitted in application ${acYear} by college`, accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { viewDocumentsDetails(row?.original?.coll_code) }}>
                        VIEW </button>
                </>)
            }
        },
        {
            Header: `Committee Photos`, accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { navigatetoCommitephotos(row?.original?.coll_code) }}
                    > VIEW </button>
                </>)
            }
        },
        {
            Header: `Mobile App Photos`, accessor: "",
            Cell: ({ row }) => {
                return (<>
                    <button type="button" className="btn text-center btn-primary btn-sm"
                        onClick={() => { NavtoMobileAppPhotos(row?.original?.coll_code) }}
                    > VIEW </button>
                </>)
            }
        },
    ]
    function GetUniversityDetails() {
        let url = config.url.API_URL + "getaffltottalunivcolleges";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUniversityData(res?.data?.data)
                setDrillCount(0)
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setTotalCollegesUniversityWiseData([])
            }
        })
    }
    function GettUniversityWiseCollegeDetails(ubcode) {
        let url = config.url.API_URL + "getaffltottalcollegesunivwise/" + ubcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setTotalCollegesUniversityWiseData(res?.data?.data)
                // setDrillCount(1)
                setDrillCount()
                setUniversitywiseTable(true)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setTotalCollegesUniversityWiseData([])
            }
        })
    }


    const collegebuildingColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "Document No./Year", accessor: "reg_no",
        },

        {
            Header: "Date of Registration (dd/mm/yyyy)", accessor: "reg_date",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.reg_date}</div>
            ),
        },
        {
            Header: "Survey No.", accessor: "survey_no",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'right' }}>{row?.values?.survey_no}</div>
            ),
        },
        {
            Header: "Extent of Land (in Acres)", accessor: "area_acres",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'right' }}>{row?.values?.area_acres}</div>
            ),
        },
        {
            Header: "District", accessor: "dist_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.dist_name}</div>
            ),
        },
        {
            Header: "SRO Division", accessor: "sro_div_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.sro_div_name}</div>
            ),
        },
        {
            Header: "Registrar Office", accessor: "sro_location",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.sro_location}</div>
            ),
        },

        {
            Header: "Upload Land Registration Document", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.upload_reg_doc === "-" ? ("-") : (
                        <button type="button" className="btn text-center"
                            onClick={() => { viewImage(row?.original?.upload_reg_doc) }}>
                            <FaDownload size={20} /> </button>)
                    }</>)
            }
        },
        {
            Header: "Upload Land EC", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.land_ec_doc === "-" ? ("-") : (
                        <button type="button" className="btn text-center"
                            onClick={() => { viewImage(row?.original?.land_ec_doc) }}>
                            <FaDownload size={20} /> </button>)
                    }</>)
            }
        },
        {
            Header: "Is Land Mortagaged", accessor: "is_land_mortgaged",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.is_land_mortgaged}</div>
            ),
        },
        {
            Header: "Mortagage registrared Document No", accessor: "mortgage_registered_doc_no",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.mortgage_registered_doc_no}</div>
            ),
        },

    ]
    const [CollegeBuldingDetails, setCollegeBuldingDetails] = useState([])
    const [collegebuildingdatesDetails, setcollegebuildingdatesDetails] = useState([])
    function viewCollegeBuldingDetails(collcode) {
        let url = config.url.API_URL + "getafflcollegebuildingdetails/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCollegeBuldingDetails(res?.data?.collegebuildingsurvey)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(true);
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
                setcollegebuildingdatesDetails(res?.data?.collegebuildingdates)

            }
            else {
                setCollegeBuldingDetails([])
                setcollegebuildingdatesDetails([])
            }
        })
    }
    const [buildingBlockDetails, setBuildingBlockDetails] = useState([])
    function viewBuldingBlockDetails(collcode) {
        let url = config.url.API_URL + "getafflcollegebuildingblockdetails/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setBuildingBlockDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(true)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setBuildingBlockDetails([])
            }
        })
    }
    const buildingBlockColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },

        {
            Header: "Building/Block Name", accessor: "build_block_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.build_block_name}</div>
            ),
        },
        {
            Header: "Building Image", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.building_img === "-" ? ("-") : (
                        <button type="button" className="btn  btn-primary text-center"
                            onClick={() => { viewImage(row?.original?.building_img) }}>
                            <IoEye size={20} /> </button>)
                    }</>)
            }
        },
    ]
    const [classroomDetails, setclassroomDetails] = useState([])
    const [classroomDetailsTable, setclassroomDetailsTable] = useState(false)

    function viewClassRoomDetails(collcode) {
        let url = config.url.API_URL + "collegeinstructionalDetails/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setclassroomDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(true)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setclassroomDetails([])
            }
        })
    }

    const classroomColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },

        {
            Header: "Particulars", accessor: "particular_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.particular_name}</div>
            ),
        },
        {
            Header: "Building/Block Name", accessor: "build_block_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.build_block_name}</div>
            ),
        },
        {
            Header: "Level/Floor No.", accessor: "floor_no_build_block",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.floor_no_build_block}</div>
            ),
        },
        {
            Header: "Room no.", accessor: "no_of_rooms",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.no_of_rooms}</div>
            ),
        },
        {
            Header: "Image", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.building_img === "-" ? ("-") : (
                        <button type="button" className="btn btn-primary text-center "
                            onClick={() => { viewImage(row?.original?.building_img) }}>
                            <IoEye size={20} /> </button>)
                    }</>)
            }
        },
    ]



    const [laboratoryDetails, setLaboratoryDetails] = useState([])
    const [laboratoryDetailsTable, setLaboratoryDetailsTable] = useState(false)

    function viewLaboratoryDetails(collcode) {
        let url = config.url.API_URL + "collegelablDetails/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setLaboratoryDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(true)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setLaboratoryDetails([])
            }
        })
    }

    const documentsColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },

        {
            Header: "Document Type", accessor: "document_type",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.document_type}</div>
            ),
        },
        {
            Header: "Document Description", accessor: "doc_descrption",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.doc_descrption}</div>
            ),
        },
        {
            Header: "Document Date", accessor: "doc_uploading_date",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.doc_uploading_date}</div>
            ),
        },

        {
            Header: "Document Upload", accessor: "",
            Cell: ({ row }) => {
                return (<>
                    {row?.original?.doc_uploading === "-" ? ("-") : (
                        <button type="button" className="btn text-center"
                            onClick={() => { viewImage(row?.original?.doc_uploading) }}>
                            <FaDownload size={20} /> </button>)
                    }</>)
            }
        },
    ]
    const [DocumentsDetails, setDocumentsDetails] = useState([])
    const [DocumentsDetailsTable, setDocumentsTable] = useState(false)

    function viewDocumentsDetails(collcode) {
        let url = config.url.API_URL + "collegedocumnets/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setDocumentsDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(true)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(false)
            }
            else {
                setDocumentsDetails([])
            }
        })
    }

    const [CommitteePhotosDetails, setCommitteePhotosDetails] = useState([])
    const [CommitteePhotosTable, setCommitteePhotosTable] = useState(false)

    function viewCommitteePhoto(collcode) {
        let url = config.url.API_URL + "collegedocumnets/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCommitteePhotosDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(true)
                setMobileAppPhotosTable(false)
            }
            else {
                setCommitteePhotosDetails([])
            }
        })
    }


    const [MobileAppPhotosDetails, setMobileAppPhotosDetails] = useState([])
    const [MobileAppPhotosTable, setMobileAppPhotosTable] = useState(false)

    function viewMobileAppPhotos(collcode) {
        let url = config.url.API_URL + "collegedocumnets/" + collcode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setMobileAppPhotosDetails(res?.data?.data)
                setDrillCount()
                setUniversitywiseTable(false)
                setClgBuildingDetailsTable(false)
                setBuildingBlockDetailsTable(false)
                setclassroomDetailsTable(false)
                setLaboratoryDetailsTable(false)
                setDocumentsTable(false)
                setCommitteePhotosTable(false)
                setMobileAppPhotosTable(true)
            }
            else {
                setMobileAppPhotosDetails([])
            }
        })
    }
    useEffect(() => { GetUniversityDetails() }, [])
    function isBackFunction() {
        setDrillCount(showDrillCount - 1)
    }
    return (
        <div>
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                    {showDrillCount === 0 && (<>
                        <div className="inner-herbpage-service-title-sub pt-0"  >
                            <h1>{`Total Colleges Data, Ac-Year - ${acYear}`}</h1>
                        </div>
                        <bie.Row className="my-3 px-3">
                            <div className="table-responsive">
                                <CommonReactTable data={showUniversityData} columns={Columns}
                                    filename={`Total Colleges Data, Ac-Year - ${acYear}`}
                                    headerName={`Total Colleges Data, Ac-Year - ${acYear}`} showFooter={"true"} />
                            </div>
                        </bie.Row>
                    </>)}
                    {/* {showDrillCount === 1 && ( */}
                    {showUniversitywiseTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Total Colleges Data, ${showuniversityName}`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setDrillCount(0)
                                    setClgBuildingDetailsTable(false);
                                    setUniversitywiseTable(false)
                                    setBuildingBlockDetails(false)
                                }} >Back</button>
                            </bie.Col>
                            <div className="table-responsive">
                                <CommonReactTable data={showTotalCollegesUniversityWiseData} columns={totalcollegeColumns} filename={`Total Colleges Data, ${showuniversityName}`}
                                    headerName={`Total Colleges Data, ${showuniversityName}`}
                                // isBack={true} isBackFunction={isBackFunction}
                                />
                            </div>
                        </bie.Row>
                    )}
                    {showClgBuildingDetailsTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Land details Report`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setClgBuildingDetailsTable(false);
                                    setUniversitywiseTable(true)
                                }} >Back</button>
                            </bie.Col>
                            <div>
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1"
                                    role="presentation" aria-hidden="true">
                                    <tbody>
                                        <tr><th>Type of College Accomodation:</th>
                                            <td style={{ textAlign: "left" }}>{collegebuildingdatesDetails[0]?.build_own_lease} </td>
                                            <th>Strength of the college:</th>
                                            <td style={{ textAlign: "left" }}>{collegebuildingdatesDetails[0]?.college_strength} </td>
                                        </tr>
                                        <tr>
                                            <th>Is any other College running in the same Premises :</th>
                                            <td style={{ textAlign: "left" }}>{collegebuildingdatesDetails[0]?.same_primises}</td>
                                            <th></th>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-responsive">
                                <CommonReactTable data={CollegeBuldingDetails} columns={collegebuildingColumns}
                                    filename={`Land details Report`}
                                    headerName={`Land details Report`}
                                    excelFlag={false} printFlag={false} SearchFlag={false}
                                    paginationCount="All"

                                // isBack={true} isBackFunction={isBackFunction} 
                                />
                            </div>
                        </bie.Row>
                    )}
                    {showBuildingBlockDetailsTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Building Blocks Details & Pictures`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setBuildingBlockDetailsTable(false);
                                    setUniversitywiseTable(true)
                                }} >Back</button>
                            </bie.Col>

                            <div className="table-responsive">
                                <CommonReactTable data={buildingBlockDetails} columns={buildingBlockColumns}
                                    filename={`Building Blocks Details & Pictures`}
                                    headerName={`Building Blocks Details & Pictures`}
                                // isBack={true} isBackFunction={isBackFunction}
                                />
                            </div>
                        </bie.Row>
                    )}

                    {classroomDetailsTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Building Blocks Details & Pictures`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setclassroomDetailsTable(false)
                                    setBuildingBlockDetailsTable(false);
                                    setUniversitywiseTable(true)
                                }} >Back</button>
                            </bie.Col>

                            <div className="table-responsive">
                                <CommonReactTable data={classroomDetails} columns={classroomColumns}
                                    filename={`Class Room Details & Pictures`}
                                    headerName={`Class Room Details & Pictures`}
                                // isBack={true} isBackFunction={isBackFunction}
                                />
                            </div>
                        </bie.Row>
                    )}

                    {laboratoryDetailsTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Laboratory Details & Pictures`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setclassroomDetailsTable(false)
                                    setBuildingBlockDetailsTable(false);
                                    setUniversitywiseTable(true)
                                    setLaboratoryDetailsTable(false)
                                }} >Back</button>
                            </bie.Col>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Lab Type</th>
                                            <th>Lab Name </th>
                                            <th>Building/Block Name</th>
                                            <th>Level/Floor No.</th>
                                            <th>Lab Image</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {laboratoryDetails !== undefined && laboratoryDetails?.map((data, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.lab_type || '-'}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.lab_details || '-'}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.build_block_name || '-'}</td>
                                                        <td style={{ textAlign: "right" }}>{data?.floor_no_build_block || '-'}</td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <button type="button" className="btn btn-primary text-center"
                                                                onClick={() => { viewImage(data?.building_img) }}>
                                                                <IoEye size={20} /> </button></td>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </bie.Row>
                    )}

                    {DocumentsDetailsTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Document Uploads Detailed Report`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setclassroomDetailsTable(false)
                                    setBuildingBlockDetailsTable(false);
                                    setDocumentsTable(false)
                                    setUniversitywiseTable(true)
                                }} >Back</button>
                            </bie.Col>

                            <div className="table-responsive">
                                <CommonReactTable data={DocumentsDetails} columns={documentsColumns} excelFlag={false} printFlag={false} SearchFlag={false}
                                    paginationCount="All"
                                    filename={`Document Uploads Detailed Report`}
                                    headerName={`Document Uploads Detailed Report`}
                                // isBack={true} isBackFunction={isBackFunction}
                                />
                            </div>
                        </bie.Row>
                    )}

                    {CommitteePhotosTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`FFCA Committee Photos`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setclassroomDetailsTable(false)
                                    setBuildingBlockDetailsTable(false);
                                    setDocumentsTable(false)
                                    setUniversitywiseTable(true)
                                    setCommitteePhotosTable(false)
                                }} >Back</button>
                            </bie.Col>

                        </bie.Row>
                    )}

                    {MobileAppPhotosTable === true && (
                        <bie.Row className="my-3 px-3">
                            <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{`Affiliation FFCA College App Details 2024-25`}</h1> </div>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                                <button type='button' className="btn btn-primary btn-sm" onClick={() => {
                                    setclassroomDetailsTable(false)
                                    setBuildingBlockDetailsTable(false);
                                    setDocumentsTable(false)
                                    setUniversitywiseTable(true)
                                    setCommitteePhotosTable(false)
                                    setMobileAppPhotosTable(false)
                                }} >Back</button>
                            </bie.Col>


                        </bie.Row>
                    )}


                </bie.Container>
            </bie.Container>
        </div>
    )
}
